import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'ex-ev-select-option',
  templateUrl: './ex-ev-select-option.component.html',
  styleUrls: ['./ex-ev-select-option.component.scss']
})
export class ExEvSelectOptionComponent {
  @Input() list: string[]
  @Input() value: string;
  @ViewChild("searchInput") searchInput?: ElementRef;
  @Output() select = new EventEmitter()
  active = false;
  options: string[]

  ngOnInit(){
    this.options = [...this.list]
  }

  isSelected(option: any) {
    
    return option === this.value;
  }

  toggleActivity() {
    this.active = !this.active;
    if (this.active) setTimeout(() => {this.searchInput?.nativeElement.focus()}, 10);
  }

  toggleValue(option: any) {
    this.select.emit(option)
    this.isSelected(option) ? (this.value = null) : (this.value = option);
    this.select.emit(this.value)
    this.active = false;
  }

  onInput(event) {
    this.updateOptions(event.target.value);
  }

  updateOptions(search) {
    this.options = this.list.filter(option=>option.includes(search));
  }

}
